import { UseQueryResult, useQuery } from 'react-query'
import request from '../../../request'
import { useDealership } from '../../../../store/zustand/dealershipStore'

type ResultType = {
  id: number
  customer_source: string
  saas_customer_source_type: number
  customerCount: number
  salesCount: number
  leadsCount: number
  serviceCount: number
  initialDate: Date
  initialCount: number
  currentCount: number
  currentDelta: number
  oldestAction: Date
  sourceTimeline: Array<{
    date: string
    items: number
    type: 'matchBack' | 'sourceUpdate'
  }>
  chartData: Array<{
    type: 'sales' | 'service' | 'leads' | 'customers'
    data: Array<{ date: string; items: number }>
  }>
}

export const useGetCustomerSourceDetailsById = (
  customer_source_id: string | number,
): UseQueryResult<ResultType, Error> => {
  const dealership = useDealership()
  return useQuery<ResultType, Error>(
    ['customerSources', 'details', dealership?.id, customer_source_id],
    ({ signal }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/sources/${customer_source_id}/details`,
        method: 'GET',
        signal,
      }),
    {
      enabled: !!customer_source_id,
    },
  )
}
